$('.menu-drawer__navigation > ul > li > details > summary').on('click', function () {
  $(this).closest('details').find('> div details:not(:has(a[href="#"]))').attr('open', true);
});
$('header-drawer').on('click', function () {
  if ($('.drawer').hasClass('active')) {
    $('.drawer__close').click();
  }
  if ($('#search-modal').hasClass('active')) {
    $('.search__close').click();
  }
});
$('.header-wrapper .searchBox').on('click', function () {
  $('#search-icon-open').click();
})
$('.header__search').on('click', function () {
  if ($('#menu-drawer').css('visibility') == 'visible') {
    $('.header__modal-close-button').click();
  }
  if ($('.drawer').hasClass('active')) {
    $('.drawer__close').click();
  }
})
$('.header__cart').on('click', function () {
  if ($('#menu-drawer').css('visibility') == 'visible') {
    $('.header__modal-close-button').click();
  }
  if ($('#search-modal').hasClass('active')) {
    $('.search__close').click();
  }
});

$(window).on('scroll', function () {
  if (clientWidth > 960) {
    if (scrollTop > windowScrollHeight()) {
      $('.header--left-logo .header__inline-menu:first-of-type').slideUp(150);
    } else {
      $('.header--left-logo .header__inline-menu:first-of-type').slideDown(150);
    }
  }
})
